import React, { ChangeEvent, FC } from "react";
import { Box, Tab, Tabs, Tooltip } from "@material-ui/core";
import useStyles from "./styles";

type DisabledTabInfo = {
  [key: string]: string;
};

type Props = {
  labels: string[];
  tabIndex: number;
  onChange: (evt: ChangeEvent<unknown>, value: number) => void;
  disabledTabs?: DisabledTabInfo | null;
};

const DPTabs: FC<Props> = ({
  labels,
  tabIndex,
  onChange,
  children,
  disabledTabs,
}) => {
  const classes = useStyles();

  const getTabWithLabel = (label: string) => {
    const isDisabled = !!disabledTabs && !!disabledTabs[label];

    const tab = (
      <Tab
        key={label}
        label={label}
        className={classes.tab}
        disabled={isDisabled}
      />
    );

    if (isDisabled) {
      return (
        <Tooltip
          placement={"right"}
          title={disabledTabs ? disabledTabs[label] : ""}
          key={label}
          classes={{
            tooltip: classes.tooltip,
          }}
        >
          <div>{tab}</div>
        </Tooltip>
      );
    }

    return tab;
  };

  return (
    <Box className={classes.root}>
      <Tabs
        value={tabIndex}
        onChange={onChange}
        textColor="primary"
        classes={{
          scroller: classes.scroller,
          indicator: classes.indicator,
        }}
      >
        {labels.map(label => getTabWithLabel(label))}
      </Tabs>
      <Box className={classes.tabContents}>{children}</Box>
    </Box>
  );
};

export default DPTabs;
